export function toTitleCase(str: string | null | undefined) {
	if (!str) return null
	return str[0] + str.slice(1).toLowerCase()
}

export function formatEnumLabel(str: string) {
	if (!str) return ''
	return str
		.split('_')
		.map(word => toTitleCase(word))
		.join(' ')
}
